import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { STORAGE_KEY as APP_STORAGE_KEY } from '../constants/enum.constants';
import { STORAGE_KEY as LIBRARY_STORAGE_KEY } from 'header';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private _authStatus!: boolean;
    private _authSubject = new BehaviorSubject<boolean>(this._getDefaultAuthStatus());

    private _token!: string;
    private _tokenExpiry!: string;
    private _refreshToken!: string;

    get authStatusObs() {
        return this._authSubject.asObservable();
    }

    constructor(private cookieService: CookieService, private router: Router) {}

    /**
     * This method gets the status of the user
     */
    _getDefaultAuthStatus(): boolean {
        const defaultAuthStatus = this.cookieService.get(APP_STORAGE_KEY.IS_LOGGED_IN);
        if (defaultAuthStatus && defaultAuthStatus !== 'undefined') {
            this._refreshToken = this.cookieService.get(APP_STORAGE_KEY.REFRESH_TOKEN);
            this._tokenExpiry = this.cookieService.get(APP_STORAGE_KEY.TOKEN_EXPIRE_TIME);
            this._token = this.cookieService.get(APP_STORAGE_KEY.TOKEN);

            /* Check Token Validity */
            if (this.checkTokenValidity()) {
                /* The existing token is valid, therefore update the `_authStatus` */
                this._authStatus = JSON.parse(defaultAuthStatus);
            } else this._authStatus = false;
        } else {
            this._authStatus = false;
        }
        return this._authStatus;
    }

    /**
     * Check IF `_token` Exists. If Yes, then check if hasn't expired by validating the `_tokenExpiry`
     * Else set the `_authStatus` to false
     */
    checkTokenValidity(): boolean {
        let isTokenValid: boolean;
        if (this._token && new Date(+this._tokenExpiry * 1000) >= new Date()) isTokenValid = true;
        else isTokenValid = false;
        return isTokenValid;
    }

    /* Logout Functionality */
    logout() {
        /* Delete the 4 cookies relevant to Login Functionality Flow */
        this.cookieService.delete(APP_STORAGE_KEY.IS_LOGGED_IN, '/', environment.DOMAIN, true);
        this.cookieService.delete(APP_STORAGE_KEY.TOKEN, '/', environment.DOMAIN, true);
        this.cookieService.delete(APP_STORAGE_KEY.TOKEN_EXPIRE_TIME, '/', environment.DOMAIN, true);
        this.cookieService.delete(APP_STORAGE_KEY.REFRESH_TOKEN, '/', environment.DOMAIN, true);

        /* Delete cookies that could be set on the other apps in the IXFI ecosystem */
        this.cookieService.delete(APP_STORAGE_KEY.USER, '/', environment.DOMAIN, true);
        this.cookieService.delete(APP_STORAGE_KEY.EMAIL, '/', environment.DOMAIN, true);
        this.cookieService.delete(APP_STORAGE_KEY.EMAIL_DATA, '/', environment.DOMAIN, true);
        this.cookieService.delete(APP_STORAGE_KEY.EMAIL_LOGIN, '/', environment.DOMAIN, true);
        this.cookieService.delete(APP_STORAGE_KEY.PHONE_DATA, '/', environment.DOMAIN, true);
        this.cookieService.delete(APP_STORAGE_KEY.FORM_DATA_VERIFY_OTP, '/', environment.DOMAIN, true);
        this.cookieService.delete(APP_STORAGE_KEY.GEE_TEST, '/', environment.DOMAIN, true);

        /* Delete cookies relevant to redirection and sub domain */
        this.cookieService.delete(LIBRARY_STORAGE_KEY.RETURN_URL);
        this.cookieService.delete(LIBRARY_STORAGE_KEY.IS_SUBDOMAIN);

        /* Delete Objects stored in Local Storage and Session Storage */
        localStorage.clear();
        sessionStorage.clear();

        /* Set the in-house authStatus to `false` */
        this._authStatus = false;

        /* Next the value to inform the app about the change */
        this._authSubject.next(this._authStatus);

        /* Return to homepage after successful logout */
        this.router.navigate(['']);
    }
}
